import LastTransaction from '../Pages/Reporting/LastTransaction';
import TransactionReport from '../Pages/Reporting/TransactionReport';

const ReportingComponent = () => {
    return (
        <article className="docs-article" id="section-7">

            <header className="docs-header">
                <h1 className="docs-heading">Reporting <span className="docs-time">Last updated: 2023-06-30</span>
                </h1>
                <section className="docs-intro">
                    <p>Transaction reports can be retrieved by a terminal from the backend using two APIs. The first API allows merchants to fetch the details of the last transaction conducted through the terminal. The second API enables merchants to retrieve a set of transaction information within a specific period. These transaction reports provide valuable insights into sales, customer behavior, and financial performance, helping merchants analyze and make informed business decisions based on the transaction data.</p>
                </section>
            </header>
            <LastTransaction />
            <TransactionReport />

        </article>
    );
};

export default ReportingComponent;